import { render, staticRenderFns } from "./AppealLink.vue?vue&type=template&id=345fa6c6&"
import script from "./AppealLink.vue?vue&type=script&lang=js&"
export * from "./AppealLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports